let timezon = [
    {id: 10, name: "America/Halifax", dname: "Atlantic", offset: 540, checked: 0, dst:1},
    {id: 1, name: "US/Eastern", dname: "Eastern", offset: 540, checked: 0, dst:1},
    {id: 2, name: "US/Central", dname: "Central", offset: 480, checked: 0, dst:1},
    {id: 3, name: "US/Mountain", dname: "Mountain", offset: 360, checked: 0, dst:1},
    {id: 4, name: "US/Pacific", dname: "Pacific", offset: 300, checked: 0, dst:1},
    {id: 5, name: "US/Alaska", dname: "Alaskan", offset: 360, checked: 0, dst:1},
    {id: 6, name: "US/Hawaii", dname: "Hawaiian", offset: 240, checked: 0, dst:1},
    // {id: 7, name: "US/Eastern", dname: "Eastern no DST", offset: 540, checked: 0, dst:0},
    // {id: 8, name: "US/Central", dname: "Central no DST", offset: 480, checked: 0, dst:0},
    {id: 9, name: "US/Mountain", dname: "Mountain no DST", offset: 360, checked: 0, dst:0},
    // {id: 10, name: "US/Pacific", dname: "Pacific no DST", offset: 300, checked: 0, dst:0},
    // {id: 11, name: "US/Alaska", dname: "Alaskan no DST", offset: 360, checked: 0, dst:0},
    // {id: 12, name: "US/Hawaii", dname: "Hawaiian no DST", offset: 240, checked: 0, dst:0},
]

module.exports= timezon